import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { Footer } from "~/components/ui/footer";
import { Header } from "~/components/ui/header";
import { getUser } from "~/lib/auth-middleware";

export const Route = createFileRoute("/_user")({
  beforeLoad: async ({ location }) => {
    const { fetchClerkAuth } = await import("~/routes/__root");
    const { userId: clerkUserId } = await fetchClerkAuth();
    if (!clerkUserId) {
      throw redirect({
        to: "/signin",
        search: {
          from: "auth-failure",
          redirect: location.pathname,
        },
      });
    }

    const user = await getUser(clerkUserId);

    if (!user) {
      throw redirect({
        to: "/signin",
        search: {
          from: "auth-failure",
          redirect: location.pathname,
        },
      });
    }

    return {
      user,
    };
  },
  component: UserLayout,
});

function UserLayout() {
  return (
    <div className="flex min-h-screen flex-col justify-between overflow-hidden">
      <Header />
      <div className="z-10 grow">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
